// AI-CONTEXT: See docs/features/livereport2-period-selector.md
//
// Converts a resolved period range (ISO dates) into the local Date bounds the
// live data layer expects. The graphData components pass dates through
// toMillis(), which would parse a bare ISO string as UTC midnight — shifting
// both bounds and dropping nearly the whole inclusive end day. Local Date
// objects (start 00:00:00.000, end 23:59:59.999) avoid that.

/** @param {string} iso @param {boolean} endOfDay */
const toLocalDate = (iso, endOfDay) => {
    const [y, m, d] = iso.split('-').map(Number)
    return endOfDay
        ? new Date(y, m - 1, d, 23, 59, 59, 999)
        : new Date(y, m - 1, d, 0, 0, 0, 0)
}

/**
 * @param {{start: string|null, end: string|null}|null|undefined} range
 * @returns {{startDate: Date|null, endDate: Date|null}}
 */
const periodRangeToDates = (range) => ({
    startDate: range?.start ? toLocalDate(range.start, false) : null,
    endDate: range?.end ? toLocalDate(range.end, true) : null,
})

export default periodRangeToDates
